import React from "react";
import Translate from "react-translate-component";
import FormattedAsset from "../../Utility/FormattedAsset";
export const VestingBalanceCreate = ({
  op,
  linkToAccount,
  fromComponent
}) => {
  if (fromComponent === "proposed_operation") {
    return /*#__PURE__*/React.createElement("span", null, "\xA0", linkToAccount(op[1].creator), /*#__PURE__*/React.createElement(Translate, {
      component: "span",
      content: "proposal.vesting_balance_create"
    }), "\xA0", /*#__PURE__*/React.createElement(FormattedAsset, {
      style: {
        fontWeight: "bold"
      },
      amount: op[1].amount.amount,
      asset: op[1].amount.asset_id
    }), "\xA0", linkToAccount(op[1].owner));
  } else {
    return /*#__PURE__*/React.createElement("span", null, "\xA0", linkToAccount(op[1].creator), /*#__PURE__*/React.createElement(Translate, {
      component: "span",
      content: "transaction.vesting_balance_create"
    }), "\xA0", /*#__PURE__*/React.createElement(FormattedAsset, {
      amount: op[1].amount.amount,
      asset: op[1].amount.asset_id
    }), "\xA0", linkToAccount(op[1].owner));
  }
};